<div class="mkt-announcement-template-dialogBox">
  <div class="template-header mb-0">
    <div class="ui-g-12 flex-between-center py-0">
      <div class="flex-start-center width-100p">
        <i class="far fa-bullseye header-icon"></i>
        <div class="template-description width-100p p-relative">
          <app-input id="template-name" type="text" placeholder="Template name*" styleClassInput="width-100p"
            [maxLength]="100" theme="secondary" [fontSize]="14" [value]="template?.name" [errorMessage]="errors?.name"
            [isInvalid]="errors?.name" (appChange)="handleChange('name', $event)">
          </app-input>
        </div>
        <i id="template-close-dialog" class="far fa-times pointer dialog-close" (click)="closeDialog()"></i>
      </div>
    </div>
  </div>
  <div class="row announcement-dialog-body">

    <div class="ui-g-12 p-0 input-default-style mb-3" style="margin-top: 15px !important;">
      <div class="ui-g-12 p-0 flex-start-center">
        <div class="icon flex-center-start ml-3 mr-1">
          <i class="far fa-envelope height-icon font-14 m-right-5"></i>
        </div>

        <div class="width-100p m-left-9">
          <app-input id="template-subject-announcement" type="text" placeholder="Email subject" theme="light"
            [fontSize]="14" [value]="template.subject" [isInvalid]="errors.subject" [floatingLabel]="true"
            [errorMessage]="errors?.subject" [maxLength]="100" (appFocus)="errors.subject = ''"
            (appChange)="handleChange('subject', $event)">
          </app-input>
        </div>
      </div>
    </div>
    <div class="col-12">
      <email-editor style="height: 500px;" [tools]="options" id="template" #editor></email-editor>
    </div>
  </div>
  <!-- Template body ends -->
  <!-- Start Add Parts Footer -->
  <div class="ui-g-12 flex-between-center dialog-footer part-footer pt-2 pb-2">
    <div class="part-add-dialog-footer width-100p row m-0">
      <div class="align-self-center col-4 input-default-style mb-0 p-left-6">
        <button type="button" *ngIf="!isOpenedFromCampaign" class="btn btn-primary ml-1 btn-transparent"
          (click)="sendPreviewEmail()" [disabled]="isSending">
          <span [ngClass]="{'pr-2': isSending}">Send preview email</span>
          <i *ngIf="isSending" class="far fa-spinner rotate"></i>
        </button>
        <span *ngIf="isOpenedFromCampaign" class="width-100p">
          <app-checkbox inputId="update-campaign-global-flag" label="Also update template across application"
            [isChecked]="isUpdateMasterTemplate" (appChange)="isUpdateMasterTemplate = $event">
          </app-checkbox>
        </span>
      </div>
      <div class="col-2"></div>
      <div class="col-6 footer-btn m-top-1 p-right-2">
        <button id="template-cancel-btn" class="btn btn-white btn-border pointer btn-submit mr-2"
          (click)="closeDialog()">
          Cancel
        </button>
        <button id="template-save-btn" class="btn btn-primary btn-submit" [disabled]="isLoading" (click)="save()">
          <span [ngClass]="{'pr-2': isLoading}">Save</span>
          <i *ngIf="isLoading" class="far fa-spinner rotate"></i>
        </button>
      </div>
    </div>
  </div>
  <!-- End Add Parts Footer -->
</div>